<nz-breadcrumb class="my-3">
  <nz-breadcrumb-item>
    <span nz-icon nzType="home"></span>
  </nz-breadcrumb-item>
  <nz-breadcrumb-item *ngFor="let crumb of crumbs; last as isLast">
    <a *ngIf="!isLast" [routerLink]="crumb.route">
      <span nz-icon [nzType]="crumb?.icon"></span>
      <span>{{ crumb?.title }}</span>
    </a>
    <span *ngIf="isLast">{{ crumb?.title }}</span>
  </nz-breadcrumb-item>
</nz-breadcrumb>
